import { toNumber, toOptionalNumber } from '@albacross/frontend-utils'

export const CPM_OPTIONS = Object.entries({
  10: '10 EUR',
  12: '12 EUR',
  15: '15 EUR',
  20: '20 EUR',
  30: '30 EUR',
  40: '40 EUR',
  100: '100 SEK',
  120: '120 SEK',
  150: '150 SEK',
  200: '200 SEK',
  250: '250 SEK',
  300: '300 SEK',
  400: '400 SEK',
}).map(([value, label]) => ({ value, label }))

export const REGIONS = Object.entries({
  emea: 'emea',
  americas: 'americas',
  apac: 'apac',
  lac: 'lac',
}).map(([value, label]) => ({ value, label }))

export type CampaignReview = {
  id: number
  customer: string
  customerId: number
  title: string
  url: string
  startDate: string
  endDate: string
  cpm: number
  currency: string
  dailyBudget: number
  extraViewsPercent: number
  targetsNumber: number
  countries: string[]
  usCampaign: boolean
  assignedUserId: number
  region: string
}

export const emptyCampaignReview = (): CampaignReview => ({
  id: 0,
  customer: '',
  customerId: 0,
  title: '',
  url: '',
  startDate: '',
  endDate: '',
  cpm: 0,
  currency: '',
  dailyBudget: 0,
  extraViewsPercent: 0,
  targetsNumber: 0,
  countries: [],
  usCampaign: false,
  assignedUserId: 0,
  region: '',
})

export const campaignReviewFromServer = (x?: any): CampaignReview =>
  x
    ? {
        id: x.id,
        customer: x.customer_name,
        customerId: x.customer_id,
        title: x.title,
        url: x.url,
        startDate: x.start_date,
        endDate: x.end_date,
        cpm: x.cpm,
        currency: x.currency,
        dailyBudget: x.budget_daily,
        extraViewsPercent: x.exchange_extra_views_percent,
        targetsNumber: x.targets_no,
        countries: x.countries || [],
        usCampaign: x.us_campaign,
        assignedUserId: x.adops_id,
        region: x.region,
      }
    : emptyCampaignReview()

export const campaignReviewToServer = x => ({
  adform_id: toOptionalNumber(x.adformId),
  start_date: x.startDate,
  end_date: x.endDate,
  cpm: toNumber(x.cpm),
  budget_daily: toNumber(x.dailyBudget),
  url: x.url,
  title: x.title,
  exchange_extra_views_percent: parseFloat(x.extraViewsPercent.toFixed(2)),
  adops_id: toOptionalNumber(x.assignedUserId),
  region: x.region,
  customer_id: toNumber(x.customer.id),
  customer: x.customer.name,
})

// OpenAPI AdExchangeCreateRequest for POST /campaigns/:id/ad_exchange.
type AdExchangeCreateRequest = {
  above_the_fold: boolean
  template?: { id: number; name: string }
}

export const createCampaignToServer = (x: any): AdExchangeCreateRequest => ({
  above_the_fold: x.aboveTheFold || false,
  template: x.templateId &&
    x.templateName && {
      id: Number(x.templateId),
      name: x.templateName,
    },
})
